export default __webpack_public_path__ + "50c11d0ac85efe25d0362d8836c2fc2d.png";